export default __webpack_public_path__ + "static/taskdeploy6-efcc581da5325ccd5669c2d271ba8f67.png";